import { Stack, Container, Typography, Box } from '@mui/material';
import { LoginForm } from '../sections/authentication/login';
import AuthBrandPanel from '../components/authentication/AuthBrandPanel';
import { AuthRootStyle, AuthSectionStyle, AuthContentStyle } from '../components/authentication/authLayoutStyles';

export default function Login() {
  return (
    <AuthRootStyle title={`Login | ${process.env.REACT_APP_PROJECTNAME}`}>
      <AuthSectionStyle className="login_logo" sx={{ display: { xs: 'none', md: 'flex' } }}>
        <AuthBrandPanel />
      </AuthSectionStyle>

      <Container maxWidth="sm">
        <AuthContentStyle>
          <Box sx={{ display: { xs: 'flex', md: 'none' }, justifyContent: 'center', mb: 4 }}>
            <AuthBrandPanel compact />
          </Box>

          <Stack sx={{ mb: 5 }}>
            <Typography
              className="heading_center"
              sx={{ color: '#F3F4F6 !important' }}
              variant="h4"
              gutterBottom
            >
              Login to {process.env.REACT_APP_PROJECTNAME}
            </Typography>
            <Typography className="heading_center" sx={{ color: '#9CA3AF !important' }}>
              Enter your details below.
            </Typography>
          </Stack>

          <LoginForm />
        </AuthContentStyle>
      </Container>
    </AuthRootStyle>
  );
}
